/**
 * Inactive With Stock Exception Config
 *
 * Covers: ex-product-ls-inactive-with-stock
 *
 * Inactive Lightspeed products still holding on-hand stock. The product
 * status chip already communicates "Inactive", so no cross-row error
 * chip is emitted for this code.
 */
import { buildProductExceptionConfig } from '../shared/productExceptionColumns'

export const inactiveWithStockConfig = buildProductExceptionConfig({
  codes: ['ex-product-ls-inactive-with-stock'],
  rowKeyField: 'row_key',
  // Stock-driven: lead each outlet cell with stock count, avg cost below.
  outletMode: 'stock',
})
